import { SelectBox } from "components/Select/Select";
import { InputHTMLAttributes, useEffect, useState } from "react";
import { getParameterDataTypeApi } from "./api";

import { InputLoad } from "components/InputLoading/inputLoading";

interface ParameterDataTypeProp extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  value?: any;
  mode?: string;
  required?:boolean 
  onChange?: (e) => void,
  defaultValue?:any
  isMethod?:any
}
export const ParameterDataTypeDictionary = ({   name,defaultValue, isMethod,value ,mode , required ,onChange }: ParameterDataTypeProp) => {
  const [optionsParameterDataType, setOptionsParameterDataType] = useState<any>();
  const [errcode, setErrcode] = useState<any>();
  const getParameterDataTypeAsync = async ()=>{
    const res = await getParameterDataTypeApi(isMethod)
    if(res?.Data ==null){
      setOptionsParameterDataType(res?.Data)
    }else{
      setOptionsParameterDataType(res?.Data)

    }
    try {
    } catch (error:any) {
      setErrcode(error.response.status)

    }
  }
  useEffect(() => {
    getParameterDataTypeAsync()
    return () => {
     
      setErrcode("")
    };
   
  }, []);
  useEffect(()=>{
    if(defaultValue){
      onChange&& onChange(defaultValue)
    }
  },[defaultValue])

 return (
    <>
        {optionsParameterDataType ?
            <div style={{display:"flex" , }} >
            <div style={{width:"100%"}}>
            <SelectBox
              onChange={(e)=>{onChange&& onChange(e.target.value) }}
              required={required}
              mode={mode}
              lable="ParameterDataType"
              selectType="select"
              value={value?.includes("Enums") ? "Enumerations" : value}
              options={ Object.values(optionsParameterDataType) }
              val={ Object.keys(optionsParameterDataType)}
              name={name}
            ></SelectBox>
            </div>
          </div>
        :<InputLoad   msg={errcode} required={required}  labelText={"ParameterDataType"}  onClick={getParameterDataTypeAsync}/> 

      }
        <div className="text-box__msg-wrapper">
        </div>
    </>
  );
};
